import { UserSetup } from '@/components/admin'
import { ROLE_CAPABILITIES } from '@/utils/role-capabilities'
import { useSelector } from 'react-redux'

export function MTAdminUserSetup() {
  // State
  const roleTypes = useSelector((state: any) => state.user.role)

  // Derived Data
  const roleConfig =
    ROLE_CAPABILITIES[roleTypes as keyof typeof ROLE_CAPABILITIES] ||
    ROLE_CAPABILITIES.default

  // Return
  return <UserSetup roleConfig={roleConfig} />
}
